import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ClaimDeductible } from '@cms-max/medicare-api-sdk'
import { ClaimDetailsField } from './ClaimDetailsField'

export interface ClaimDeductibleCardProps {
  deductible:ClaimDeductible
}

export const ClaimDeductibleCard: FC<ClaimDeductibleCardProps> = ({ deductible }) => {
  const { t } = useTranslation('claimsSearch', { keyPrefix: 'claimDeductibles' })

  return (
    <>
        <div className='ds-l-row'>
          <div className='ds-l-col'>
            {deductible.deductibleYear && (
              <ClaimDetailsField
                label={t('deductibleYear')}
                value={deductible.deductibleYear}
              />
            )}
          </div>
          <div className='ds-l-col'>
            {deductible.deductibleRemaining && (
              <ClaimDetailsField
                label={t('partBDeductibleRem')}
                value={deductible.deductibleRemaining}
              />
            )}
          </div>
          <div className='ds-l-col'>
            {deductible.occupationalTherapyApplied && (
              <ClaimDetailsField
                label={t('occupationalApplied')}
                value={deductible.occupationalTherapyApplied}
              />
            )}
          </div>
        </div>
        <div className='ds-l-row'>
          <div className='ds-l-col'>
            {deductible.deductibleAmount && (
              <ClaimDetailsField
                label={t('partBDeductibleAmt')}
                value={deductible.deductibleAmount}
              />
            )}
          </div>
          <div className='ds-l-col'>
            {deductible.deductibleAmountMet && (
              <ClaimDetailsField
                label={t('deductibleMet')}
                value={deductible.deductibleAmountMet}
              />
            )}
          </div>
          <div className='ds-l-col'>
            {deductible.physicalSpeechTherapyApplied && (
              <ClaimDetailsField
                label={t('PhysSpeechApplied')}
                value={deductible.physicalSpeechTherapyApplied}
              />
            )}
          </div>
        </div>
    </>
  )
}
